<template>
  <div class="mx-auto max-w-screen-xl px-6 lg:px-10" data-testid="narrow-container">
    <slot />
  </div>
</template>
